import diamondSearch from './diamond-search'
import jewelrySearch from './jewelry-search'
import client from './client'
import cart from './cart'
import settings from './settings'
import summary from './summary'
import currentUser from './current-user'
import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'

export const CURRENT_STATE_VERSION = 16

const appReducer = combineReducers({
  diamondSearch,
  jewelrySearch,
  client,
  cart,
  settings,
  summary,
  currentUser,
  form: formReducer
})

const rootReducer = (state, action) => {
  if (action.type === 'USER_LOGOUT') {
    state = {}
  }
  if (action.type === 'NEW_SESSION') {
    const { currentUser } = state
    state = { currentUser }
  }
  return appReducer(state, action)
}

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js